import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { ngxZendeskWebwidgetService } from 'ngx-zendesk-webwidget';
import { Store } from '@ngxs/store';
import { Logout } from 'src/app/auth/state/auth/auth.actions';

@Component({
  selector: 'app-mobile-nav',
  templateUrl: './mobile-nav.component.html',
  styleUrls: ['./mobile-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class MobileNavComponent implements OnInit {

  constructor(
    private store: Store,
    private zendeskService: ngxZendeskWebwidgetService
  ) { }

  ngOnInit() {
  }

  handleHelpClicked() {
    this.showZendeskWidget();
  }

  handleLogout() {
    this.store.dispatch(new Logout());
  }

  showZendeskWidget() {
    this.zendeskService.activate({
      hideOnClose: true
    });
  }
}
